import React, { ReactNode, createContext, useMemo } from "react";
import {
  Client,
  getContract,
  GetContractReturnType,
  PublicClient,
  WalletClient,
} from "viem";
import ISpeedRacer from "./ISpeedRacer";
import { useConnection } from "@eveworld/contexts";

interface SpeedRacerContract {
  SpeedRacerContract: GetContractReturnType<
    typeof ISpeedRacer.abi,
    Client
  > | null;
}

const SpeedRacerProvider = ({ children }: { children: ReactNode }) => {
  const { defaultNetwork, publicClient, walletClient } = useConnection();

  const SpeedRacerContract = useMemo(
    () =>
      getContract({
        abi: ISpeedRacer.abi,
        address: defaultNetwork.worldAddress,
        client: {
          public: publicClient as PublicClient,
          wallet: walletClient as WalletClient,
        },
      }),
    [publicClient, walletClient]
  );

  return (
    <SpeedRacerContext.Provider value={{ SpeedRacerContract }}>
      {children}
    </SpeedRacerContext.Provider>
  );
};

export const SpeedRacerContext = createContext<SpeedRacerContract>({
  SpeedRacerContract: null,
});

export default SpeedRacerProvider;
